export const defaultLang = "th";

export const supportedLangs = {
  en: "English",
  th: "Thailand",
};

export const langUrl = "/lang/{lang}.json";
